import { faUser as faRegUser } from '@fortawesome/free-regular-svg-icons/faUser';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faUserTie } from '@fortawesome/free-solid-svg-icons/faUserTie';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons/faPowerOff';
import { faBox } from '@fortawesome/free-solid-svg-icons/faBox';
import { faParachuteBox } from '@fortawesome/free-solid-svg-icons/faParachuteBox';
import { faPalette } from '@fortawesome/free-solid-svg-icons/faPalette';
import { faAddressBook } from '@fortawesome/free-solid-svg-icons/faAddressBook';
import { faBoxOpen } from '@fortawesome/free-solid-svg-icons/faBoxOpen';
import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons/faExchangeAlt';
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons/faFileInvoiceDollar';
import { faTag } from '@fortawesome/free-solid-svg-icons/faTag';
import { faFile } from '@fortawesome/free-regular-svg-icons/faFile';
import { faBuilding } from '@fortawesome/free-regular-svg-icons/faBuilding';
import { faFileSignature } from '@fortawesome/free-solid-svg-icons/faFileSignature';
import { faTruckLoading } from '@fortawesome/free-solid-svg-icons/faTruckLoading';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons/faLayerGroup';
import { faCog } from '@fortawesome/free-solid-svg-icons/faCog';
import { faUserCheck } from '@fortawesome/free-solid-svg-icons/faUserCheck';
// import { faDolly } from '@fortawesome/free-solid-svg-icons/faDolly';
import { faHandshake } from '@fortawesome/free-solid-svg-icons/faHandshake';

const links = [
  {
    to: '/admin/users',
    icon: faRegUser,
    label: 'Users',
    segment: 'users',
    links: [
      {
        to: '/admin/users/admins',
        icon: faUserTie,
        label: 'Super Admins',
        segment: 'admins',
      },
      {
        to: '/admin/users/departments',
        icon: faUser,
        label: 'User Accounts',
        segment: 'departments',
      },
      {
        to: '/admin/users/roles',
        icon: faUserCheck,
        label: 'User Roles',
        segment: 'roles',
      },
      {
        to: '/admin/users/customers',
        icon: faAddressBook,
        label: 'Customers',
        segment: 'customers',
      },
    ],
  },
  {
    to: '/admin/designs',
    icon: faPalette,
    label: 'Designs',
    segment: 'designs',
    links: [
      {
        to: '/admin/designs/items',
        icon: faPalette,
        label: 'Designs',
      },
      {
        to: '/admin/designs/tfy/colors',
        icon: faPalette,
        label: 'TFY Colors',
      },
      {
        to: '/admin/designs/tfy/palettes',
        icon: faPalette,
        label: 'TFY Palettes',
      },
      {
        to: '/admin/designs/tfy/suppliers',
        icon: faPalette,
        label: 'TFY Suppliers',
      },
      {
        to: '/admin/designs/tfy/delivery-time',
        icon: faPalette,
        label: 'TFY Delivery Time',
      },
      // {
      //   to: '/admin/designs/ar-scenes',
      //   icon: faPalette,
      //   label: 'AR Scenes',
      // },
    ],
  },
  {
    to: '/admin/stocks',
    icon: faBox,
    label: 'Stocks',
    segment: 'stocks',
    links: [
      {
        to: '/admin/stocks/items',
        icon: faBox,
        label: 'Stocks',
      },
      {
        to: '/admin/stocks/reorders/items',
        icon: faBox,
        label: 'Reorders',
      },
      {
        to: '/admin/stocks/tfy/items',
        icon: faBox,
        label: 'TFY Stocks',
      },
      {
        to: '/admin/stocks/pre-stocks',
        icon: faBox,
        label: 'On Order Stock',
      },
      {
        to: '/admin/stocks/ready-to-ship',
        icon: faParachuteBox,
        label: 'Ready To Ship',
      },
      {
        to: '/admin/stocks/records',
        icon: faFileSignature,
        label: 'On Hold Records',
      },
      {
        to: '/admin/stocks/trans',
        icon: faFileSignature,
        label: 'Stock Transfer',
      },
    ],
  },
  {
    to: '/admin/collections',
    icon: faLayerGroup,
    label: 'Collections',
    segment: 'collections',
  },
  {
    to: '/admin/collaborators',
    icon: faHandshake,
    label: 'Collaborators',
    segment: 'collaborators',
  },
  {
    to: '/admin/quotations',
    icon: faFile,
    label: 'Quotations',
    segment: 'quotations',
  },
  {
    to: '/admin/consignments',
    icon: faBoxOpen,
    label: 'Consignments',
    segment: 'consignments',
  },
  {
    to: '/admin/orders',
    icon: faTag,
    label: 'Orders',
    segment: 'orders',
  },
  {
    to: '/admin/exchange-rates',
    icon: faExchangeAlt,
    label: 'Exchange Rates',
    segment: 'exchangeRates',
  },
  {
    to: '/admin/taxations',
    icon: faFileInvoiceDollar,
    label: 'Taxations',
    segment: 'taxations',
  },
  {
    to: '/admin/showrooms',
    icon: faBuilding,
    label: 'Showrooms',
    segment: 'showrooms',
  },
  {
    to: '/admin/terms',
    icon: faFileSignature,
    label: 'Terms & Conditions',
    segment: 'terms',
  },
  {
    to: '/admin/services',
    icon: faTruckLoading,
    label: 'Services',
    segment: 'services',
  },
  {
    to: '/admin/configs',
    icon: faCog,
    label: 'Config',
    segment: 'configs',
  },
  {
    href: '/logout',
    icon: faPowerOff,
    label: 'Logout',
    required: true,
  },
];

export default links;
